// extracted by mini-css-extract-plugin
export default {"main":"ModalEditarCuadernillo_main__6LOk4","intro":"ModalEditarCuadernillo_intro__bm0BN","input":"ModalEditarCuadernillo_input__IWUVc"};